/* import __COLOCATED_TEMPLATE__ from './and-or.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();